module.exports = __webpack_public_path__ + "static/media/DevicePicOnAboutUs.83ede5a6.svg";